import { Topbar, Page } from 'components'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { AuthStore, RoutingStore } from '../stores'
import { MainSidebar, ParticipantTopbar } from '../views'

export interface ICerfificatesProps {
  authStore?: AuthStore
  routingStore?: RoutingStore
}

/**
 * Displays earned certificates to the current user.
 *
 * @type Participant, Manager
 */
export const Certificates = inject(
  'authStore',
  'routingStore'
)(
  observer((props: ICerfificatesProps) => {
    const { authStore, routingStore } = props

    return <Page sidebar={<MainSidebar />} topbar={<Topbar />}></Page>
  })
)
